import styled from 'styled-components';
import {
  quoteBlue,
  tekoMedium,
  openSansBold,
  brightBlue,
  grey,
  roboto,
  robotoBold,
} from '../../../utils/theme';
import { RTE } from '../../../utils/atoms';

export const ItemContainer = styled.div`
  position: relative;
  margin-right: 18px;
  border-bottom: 1px solid ${grey};
  cursor: pointer;

  &:hover {
    border-bottom: 2px solid ${brightBlue};
    margin-bottom: -1px;
  }

  .bullet {
    ${tekoMedium};
    font-size: 40px;
    color: ${brightBlue};
    letter-spacing: 3.19px;
    line-height: 46px;
    width: 46px;
    flex-shrink: 0;
  }

  .content {
    margin: 18px 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .question {
    opacity: 0.9;
    ${openSansBold}
    font-size: 15px;
    color: ${quoteBlue};
    letter-spacing: 0.63px;
    line-height: 27px;
  }

  .faqs__answer {
    display: block;
    padding: 9px 0 18px 46px;

    font-size: 15px;
    letter-spacing: 0.63px;
    line-height: 27px;

    :before {
      display: none;
    }
  }
`;

export const FaqRTE = styled(RTE)`
  padding: 9px 0 18px 46px;
  color: #9DABBE;
  letter-spacing: 0.63px;
  line-height: 27px;
  ${roboto}

  p {
    font-size: 15px;
  }

  h1, h2, h3, h4, h5, h6 {
    font-size: 15px;
    ${robotoBold}
    color: ${quoteBlue};
    letter-spacing: 0.63px;
    line-height: 27px;
    text-transform: none;
    margin: 0 auto;
  }
`;



// WEBPACK FOOTER //
// ./src/components/faq/styles/faqs-item.style.js